var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeDataMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 48,
    viewBox: "0 0 36 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1056 39.4472L2.89443 46.5528C1.56463 47.2177 0 46.2507 0 44.7639V2C0 0.895431 0.895432 0 2 0H34C35.1046 0 36 0.895432 36 2V44.7639C36 46.2507 34.4354 47.2177 33.1056 46.5528L18.8944 39.4472C18.3314 39.1657 17.6686 39.1657 17.1056 39.4472Z",
    fill: "#3A9E4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7073 9.87868C17.2699 9.31607 18.033 9 18.8286 9H25.0002C26.657 9 28.0002 10.3431 28.0002 12V18.1716C28.0002 18.9672 27.6841 19.7303 27.1215 20.2929L19.1215 28.2929C17.9499 29.4645 16.0504 29.4645 14.8789 28.2929L8.70729 22.1213C7.53572 20.9497 7.53572 19.0503 8.70729 17.8787L16.7073 9.87868ZM18.8286 11C18.5634 11 18.309 11.1054 18.1215 11.2929L10.1215 19.2929C9.73098 19.6834 9.73098 20.3166 10.1215 20.7071L16.2931 26.8787C16.6836 27.2692 17.3168 27.2692 17.7073 26.8787L25.7073 18.8787C25.8948 18.6911 26.0002 18.4368 26.0002 18.1716V12C26.0002 11.4477 25.5525 11 25.0002 11H18.8286Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 13.3165C25.0002 14.0436 24.4108 14.6331 23.6837 14.6331C22.9566 14.6331 22.3672 14.0436 22.3672 13.3165C22.3672 12.5894 22.9566 12 23.6837 12C24.4108 12 25.0002 12.5894 25.0002 13.3165Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2491 17.2247C17.1153 17.4397 17 17.9222 17 19C17 20.0778 17.1153 20.5603 17.2491 20.7753L17.2503 20.7772C17.2963 20.8513 17.3887 21 18 21C18.6113 21 18.7037 20.8513 18.7497 20.7772L18.7509 20.7753C18.8847 20.5603 19 20.0778 19 19C19 17.9222 18.8847 17.4397 18.7509 17.2247L18.7497 17.2228C18.7037 17.1487 18.6113 17 18 17C17.3887 17 17.2963 17.1487 17.2503 17.2228C17.2499 17.2234 17.2495 17.2241 17.2491 17.2247ZM15.5509 16.1681C16.1053 15.2772 17.0167 15 18 15C18.9833 15 19.8947 15.2772 20.4491 16.1681C20.9153 16.9174 21 17.9349 21 19C21 20.0651 20.9153 21.0826 20.4491 21.8319C19.8947 22.7228 18.9833 23 18 23C17.0167 23 16.1053 22.7228 15.5509 21.8319C15.0847 21.0826 15 20.0651 15 19C15 17.9349 15.0847 16.9174 15.5509 16.1681Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeDataMark);
export default __webpack_public_path__ + "static/media/FreeDataMark.62de7ad8dd673310f7ddaf1a24f2c098.svg";
export { ForwardRef as ReactComponent };